import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import { timelines } from "./tabs";

function generateImageTimeline(image: HTMLElement) {
  const imageTimeline = gsap.timeline({
    paused: true
  });
  imageTimeline.set(image, {
    zIndex: 2,
  });
  imageTimeline.to(image, {
    scale: 1.05,
    duration: 0.3,
    onComplete: () => {
      image.classList.add("active");
      imageTimeline.pause();
    },
  });

  imageTimeline.to(image, {
    scale: 1,
    duration: 0.3,
    onComplete: () => {
      imageTimeline.pause(0);
      imageTimeline.revert();
    },
  }, ">");


  return imageTimeline;
}

export function generateImageStaggerTimeline(tabContent: HTMLElement) {
  const introTimeline = gsap.timeline({ paused: true });

  const tabImages = tabContent.querySelectorAll(".mosaic-image");

  introTimeline.to(tabImages, {
    opacity: 1,
    duration: 0.5,
    ease: "power1.inOut",
    stagger: {
      each: 0.3, // total duration for the stagger
    },
  });

  return introTimeline;
}

function initMosaicIntro() {
  gsap.registerPlugin(ScrollTrigger);

  const heroTabs = document.querySelector(".hero-tabs");
  if (!heroTabs) {
    return;
  }

  gsap.timeline({
    scrollTrigger: {
      once: true,
      trigger: ".hero-tab-mosaic",
      start: "top 50%",
      onEnter: () => {
        timelines[0].play(0);
      },
    },
  });
}

function initMosaic() {
  const heroTabs = document.querySelector(".hero-tabs");
  if (!heroTabs) {
    return;
  }

  const tabs = Array.from(heroTabs.querySelectorAll(".tab-content"));

  tabs.forEach((tab) => {
    const mosaic = tab.querySelector(".hero-tab-mosaic");
    const mosaicGrid = mosaic?.querySelector(".mosaic-grid");
    const images = mosaicGrid?.querySelectorAll("figure");

    images?.forEach((image) => {
      if (image.classList.contains("active")) {
        return;
      }

      const tl = generateImageTimeline(image as HTMLElement);

      // add hover event listener to each image
      image.addEventListener("mouseenter", () => {
        images.forEach((img) => {
          img.classList.remove("active");
        });
        tl.play();
      });
      image.addEventListener("mouseleave", () => {
        // finish the animation (scale back down)
        tl.play();
      });
    });
  });

  // also automatically switch between images (with same animation) every 4s?
}

initMosaic();
initMosaicIntro();
